import { render, staticRenderFns } from "./CallTimeGroupList.vue?vue&type=template&id=54a3651c&scoped=true&"
import script from "./CallTimeGroupList.vue?vue&type=script&lang=js&"
export * from "./CallTimeGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3651c",
  null
  
)

export default component.exports